import {createIcon} from '@chakra-ui/react'

export const SendIcon = createIcon({
  displayName: 'SendIcon',
  viewBox: '0 0 32 32',
  path: (
    <>
      <path
        d="M29.3337 2.66699L14.667 17.3337"
        stroke="#1A1A1A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M29.3337 2.66699L20.0003 29.3337L14.667 17.3337L2.66699 12.0003L29.3337 2.66699Z"
        stroke="#1A1A1A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  ),
})
